var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{directives:[{name:"show",rawName:"v-show",value:(this.input.customized.static_image || this.input.customized.images.length > 0),expression:"this.input.customized.static_image || this.input.customized.images.length > 0"}],ref:"imageSwitchCanvas",staticStyle:{"position":"absolute","width":"100%","height":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }